import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap, Observable } from 'rxjs';
import { InterceptorsStrategyService } from './InterceptorsStrategy.service';

@Injectable({
	providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
	constructor(private interceptorsStrategyService: InterceptorsStrategyService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const strategy = this.interceptorsStrategyService.resolveStrategy(req);
		if (!strategy) {
			return next.handle(req);
		}
		if (!strategy.additionalParams) {
			return next.handle(strategy.getHttpRequest(req));
		}
		return strategy.additionalParams(req).pipe(
			mergeMap((additionalParams) => {
				return next.handle(strategy.getHttpRequest(req, additionalParams));
			})
		);
	}
}
